import { axiosGu } from "config";

export const fetchFeatureFlag = async () => {
  const response = await axiosGu.get("/feature-flag/all");
  const { data } = response;
  return data;
};
